var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStylecrackerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 46,
    viewBox: "0 0 156 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.679392
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0748 25.9444C13.1565 27.0153 13.9382 28.0054 15.5033 28.0054C16.6906 28.0054 17.2566 27.3733 17.2566 26.6601C17.2566 26.0565 16.8522 25.5607 15.8266 25.3399L14.073 24.9298C11.5112 24.3526 10.351 22.7865 10.351 20.8928C10.351 18.4757 12.4551 16.47 15.3133 16.47C19.0905 16.47 20.3585 18.9135 20.5196 20.3712L17.5271 21.0571C17.4183 20.261 16.8522 19.2442 15.3414 19.2442C14.3972 19.2442 13.6417 19.8217 13.6417 20.5898C13.6417 21.248 14.1269 21.6597 14.8555 21.7976L16.7437 22.2096C19.3597 22.7589 20.6821 24.3799 20.6821 26.3565C20.6821 28.555 19.0099 30.8066 15.5301 30.8066C11.5377 30.8066 10.1626 28.1691 10 26.6322L13.0748 25.9444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5758 17.0338H28.2178V20.2389H25.5758V25.8361C25.5758 27.0054 26.1098 27.3838 27.1236 27.3838C27.5499 27.3838 28.0318 27.3286 28.2178 27.2767V30.263C27.8979 30.4008 27.2572 30.5921 26.2157 30.5921C23.6538 30.5921 22.0545 29.0434 22.0545 26.462V20.2389L22.0283 13.041H25.5758V17.0338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1836 35.311L34.2611 28.5924L28.7168 17.3029H32.6697L36.1454 24.8631L39.356 17.3029H43.1233L34.9252 35.311H31.1836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0234 30.809H47.6251V11H44.0234V30.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.526 20.5319C84.1225 20.4502 83.772 20.422 83.4488 20.422C81.6157 20.422 80.0263 21.3271 80.0263 24.2297V30.3973H76.4404V16.914H79.9184V18.9165C80.7261 17.1329 82.5592 16.806 83.6909 16.806C83.9873 16.806 84.2565 16.832 84.526 16.8614V20.5319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2112 22.6416L92.4727 22.1489C93.228 22.0377 93.4692 21.6557 93.4692 21.1881C93.4692 20.2307 92.7422 19.4339 91.2335 19.4339C89.6693 19.4339 88.8062 20.4502 88.699 21.6281L85.5176 20.9425C85.7341 18.832 87.6476 16.5047 91.2051 16.5047C95.4104 16.5047 96.9734 18.9165 96.9734 21.6281V28.2589C96.9734 28.9723 97.0541 29.9316 97.1357 30.3976H93.8481C93.7655 30.0393 93.7119 29.3015 93.7119 28.7809C93.0385 29.8495 91.771 30.7803 89.8051 30.7803C86.9733 30.7803 85.248 28.8367 85.248 26.7258C85.248 24.3134 87.0017 22.9717 89.2112 22.6416M93.4692 24.9422V24.34L90.4772 24.806C89.5605 24.9422 88.8333 25.4637 88.8333 26.5044C88.8333 27.2986 89.3991 28.0675 90.5579 28.0675C92.0682 28.0675 93.4692 27.3293 93.4692 24.9422",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.495 23.6557C101.495 26.0929 103.058 27.4653 104.892 27.4653C106.724 27.4653 107.641 26.2313 107.936 25.1906L111.09 26.2589C110.496 28.5044 108.423 30.8066 104.892 30.8066C100.983 30.8066 97.9111 27.7944 97.9111 23.6557C97.9111 19.4897 100.929 16.5047 104.784 16.5047C108.395 16.5047 110.442 18.7794 111.01 21.0518L107.802 22.1486C107.478 21.0243 106.643 19.8739 104.864 19.8739C103.031 19.8739 101.495 21.2172 101.495 23.6557",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.892 23.0092L124.159 30.809H119.888L116.481 25.6628L115.039 27.2504V30.809H111.554V11H115.039V22.3534L119.495 17.3461H124.055L118.892 23.0092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.868 26.5327C136.201 28.8613 134.121 30.8068 130.894 30.8068C127.293 30.8068 124.121 28.1478 124.121 23.5997C124.121 19.2981 127.214 16.5045 130.575 16.5045C134.628 16.5045 137.055 19.1622 137.055 23.4904C137.055 24.0125 137.002 24.5606 137.002 24.6148H127.614C127.694 26.3952 129.161 27.6862 130.921 27.6862C132.575 27.6862 133.481 26.8337 133.908 25.6307L136.868 26.5327ZM133.561 22.1224C133.509 20.7786 132.655 19.4651 130.627 19.4651C128.787 19.4651 127.773 20.8872 127.694 22.1224H133.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.249 20.5319C145.848 20.4502 145.503 20.422 145.182 20.422C143.369 20.422 141.795 21.3271 141.795 24.2297V30.3973H138.248V16.914H141.688V18.9165C142.489 17.1329 144.301 16.806 145.422 16.806C145.714 16.806 145.982 16.832 146.249 16.8614V20.5319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8329 30.5566L56.8144 27.4912C56.4675 27.6121 56.0814 27.686 55.6278 27.686C53.867 27.686 52.4006 26.395 52.3208 24.6149H59.6143L61.6881 22.484C61.3306 18.7655 59.0047 16.5046 55.2804 16.5046C51.9215 16.5046 48.8281 19.2983 48.8281 23.5999C48.8281 27.38 51.0269 29.8263 53.8329 30.5566M55.3352 19.4649C57.3609 19.4649 58.2149 20.7787 58.2677 22.1226H52.4006C52.4814 20.887 53.4943 19.4649 55.3352 19.4649",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8031 19.8738C69.5633 19.8738 70.3902 21.0241 70.71 22.1488L73.8841 21.052C73.458 19.3226 72.1757 17.5976 70.0153 16.8688L66.9854 19.9825C67.2493 19.9189 67.5212 19.8738 67.8031 19.8738",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8295 27.4652C66.0166 27.4652 64.4688 26.0928 64.4688 23.6556C64.4688 23.188 64.5407 22.774 64.6437 22.3881L61.2666 25.8595C62.1371 28.81 64.6959 30.8069 67.8295 30.8069C71.3228 30.8069 73.3756 28.5043 73.9635 26.2588L70.8427 25.1905C70.5486 26.2312 69.6424 27.4652 67.8295 27.4652",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStylecrackerLogo);
export default __webpack_public_path__ + "static/media/stylecracker-logo.c885cca1.svg";
export { ForwardRef as ReactComponent };